import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { Loading, InputCustom, Base64Input, HttpError } from "../components"
import Layout from "../views/Layout"
import $ from "jquery"
import * as ApiHelper from "../ApiHelper"
class PersonalizarRelatorios extends Component {
  constructor() {
    super()
    this.sendForm = this.sendForm.bind(this)
    this.handleErrors = this.handleErrors.bind(this)
    this.onChangeEmail = this.onChangeEmail.bind(this)
    this.onChangeNome = this.onChangeNome.bind(this)
    this.state = {
      success: false,
      showForm: false,
      nome: "",
      email: "",
      image: "",
      defaultImage:
        "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgLTIwOC41IDIxIDEwMCAxMDAiIGlkPSJMYXllcl8xIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9Ii0yMDguNSAyMSAxMDAgMTAwIiB4bWw6c3BhY2U9InByZXNlcnZlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnNrZXRjaD0iaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoL25zIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGc+PGNpcmNsZSBjeD0iLTE1OC41IiBjeT0iNzEiIGZpbGw9IiNGNUVFRTUiIGlkPSJNYXNrIiByPSI1MCIvPjxnPjxkZWZzPjxjaXJjbGUgY3g9Ii0xNTguNSIgY3k9IjcxIiBpZD0iTWFza18yXyIgcj0iNTAiLz48L2RlZnM+PGNsaXBQYXRoIGlkPSJNYXNrXzRfIj48dXNlIG92ZXJmbG93PSJ2aXNpYmxlIiB4bGluazpocmVmPSIjTWFza18yXyIvPjwvY2xpcFBhdGg+PHBhdGggY2xpcC1wYXRoPSJ1cmwoI01hc2tfNF8pIiBkPSJNLTEwOC41LDEyMXYtMTRjMCwwLTIxLjItNC45LTI4LTYuN2MtMi41LTAuNy03LTMuMy03LTEyICAgICBjMC0xLjcsMC02LjMsMC02LjNoLTE1aC0xNWMwLDAsMCw0LjYsMCw2LjNjMCw4LjctNC41LDExLjMtNywxMmMtNi44LDEuOS0yOC4xLDcuMy0yOC4xLDYuN3YxNGg1MC4xSC0xMDguNXoiIGZpbGw9IiNFNkMxOUMiIGlkPSJNYXNrXzNfIi8+PGcgY2xpcC1wYXRoPSJ1cmwoI01hc2tfNF8pIj48ZGVmcz48cGF0aCBkPSJNLTEwOC41LDEyMXYtMTRjMCwwLTIxLjItNC45LTI4LTYuN2MtMi41LTAuNy03LTMuMy03LTEyYzAtMS43LDAtNi4zLDAtNi4zaC0xNWgtMTVjMCwwLDAsNC42LDAsNi4zICAgICAgIGMwLDguNy00LjUsMTEuMy03LDEyYy02LjgsMS45LTI4LjEsNy4zLTI4LjEsNi43djE0aDUwLjFILTEwOC41eiIgaWQ9Ik1hc2tfMV8iLz48L2RlZnM+PGNsaXBQYXRoIGlkPSJNYXNrXzVfIj48dXNlIG92ZXJmbG93PSJ2aXNpYmxlIiB4bGluazpocmVmPSIjTWFza18xXyIvPjwvY2xpcFBhdGg+PHBhdGggY2xpcC1wYXRoPSJ1cmwoI01hc2tfNV8pIiBkPSJNLTE1OC41LDEwMC4xYzEyLjcsMCwyMy0xOC42LDIzLTM0LjQgICAgICBjMC0xNi4yLTEwLjMtMjQuNy0yMy0yNC43cy0yMyw4LjUtMjMsMjQuN0MtMTgxLjUsODEuNS0xNzEuMiwxMDAuMS0xNTguNSwxMDAuMXoiIGZpbGw9IiNENEIwOEMiIGlkPSJoZWFkLXNoYWRvdyIvPjwvZz48L2c+PHBhdGggZD0iTS0xNTguNSw5NmMxMi43LDAsMjMtMTYuMywyMy0zMWMwLTE1LjEtMTAuMy0yMy0yMy0yM3MtMjMsNy45LTIzLDIzICAgIEMtMTgxLjUsNzkuNy0xNzEuMiw5Ni0xNTguNSw5NnoiIGZpbGw9IiNGMkNFQTUiIGlkPSJoZWFkIi8+PC9nPjwvc3ZnPg=="
    }
  }

  componentWillMount() {
    this.getInitialFields()
  }
  componentDidUpdate() {
    //Pequeno ajuste tecnico devido bug no datepicker
    $(".is-empty").removeClass("is-empty")
  }
  getInitialFields() {
    ApiHelper.getPersonalizacaoRelatorio((data, error) => {
      if (data) {
        this.fillFields(data)
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  fillFields(fields) {
    var currentState = {
      nome: fields.nome,
      email: fields.email,
      image: fields.file,
      showForm: true
    }
    this.setState(currentState)
  }
  getFiles(files) {
    var base64 = files.base64.split("data:" + files.type + ";base64,").join("")
    this.setState({
      image: base64,
      fileError: "",
      success: false
    })
  }
  onChangeNome(event) {
    var newValue = event.target.value
    this.setState({
      nome: newValue,
      nomeError: "",
      success: false
    })
  }
  onChangeEmail(event) {
    var newValue = event.target.value
    this.setState({
      email: newValue,
      emailError: "",
      success: false
    })
  }
  sendForm(event) {
    event.preventDefault()
    var params = {
      nome: this.state.nome,
      email: this.state.email,
      file: this.state.image
    }
    ApiHelper.sendPersonalizacaoRelatorio(params, error => {
      if (error) {
        this.handleErrors(error)
      } else {
        this.setState({
          success: true
        })
      }
    })
  }
  handleErrors(errors) {
    var errorsJSON = JSON.parse(errors)
    var errorsValue = errorsJSON.errors 
    var errorsState = {}
    for (var key in errorsValue) {
      errorsState[key + "Error"] = errorsValue[key][0]
    }
    this.setState(errorsState)
  }
  render() {
    if (this.state.httpError) {
      return (
        <HttpError
          message={this.state.httpError.message}
          status={this.state.httpError.status}
        />
      )
    }
    return (
      <Layout>
        <div>
          {this.state.showForm === false && <Loading />}
          {this.state.showForm === true && (
            <div className="card card-plain">
              <div className="card-header" data-background-color="as-blue">
                <h4 className="title">Personalizar relatórios</h4>
                <p className="category">Informações exibidas nos relatórios</p>
              </div>
              <div className="card-content">
                <InputCustom
                  error={this.state.nomeError}
                  sizeClass="col-md-4"
                  label="Nome"
                  onChange={this.onChangeNome}
                  value={this.state.nome}
                />
                <InputCustom
                  error={this.state.emailError}
                  sizeClass="col-md-4"
                  label="Email para contato"
                  onChange={this.onChangeEmail}
                  value={this.state.email}
                />
              </div>

              <div className="row">
                <div className="col-md-2 card-profile">
                  <div className="card-avatar">
                    <img
                      alt="Imagem exibida nos relatórios"
                      className="img"
                      src={
                        this.state.image !== ""
                          ? "data:image/jpeg;base64," + this.state.image
                          : this.state.defaultImage
                      }
                    />
                  </div>
                  <span className="label label-danger">
                    {this.state.fileError}
                  </span>
                </div>
                <div className="content">
                  <h6 className="category text-gray">
                    Logo exibido no relatório
                  </h6>
                  <Base64Input
                    ref={ref => (this.upload = ref)}
                    style={{ display: "none" }}
                    multiple={false}
                    onDone={this.getFiles.bind(this)}
                  />
                  <button
                    onClick={() => this.upload.click()}
                    type="button"
                    className="btn btn-danger btn-simple btn-xs"
                  >
                    Carregar nova imagem{" "}
                    <i className="material-icons">file_upload</i>
                  </button>
                </div>
              </div>
              <div className="row">
                <button
                  onClick={this.sendForm}
                  type="submit"
                  className="col-md-2 btn btn-primary pull-left"
                  data-background-color="as-blue"
                >
                  Salvar
                </button>
              </div>
              <div className="row">
                {this.state.success && (
                  <span
                    style={{
                      height: "50%",
                      fontSize: 20
                    }}
                    className="col-md-12 label label-success"
                  >
                    Alterado com sucesso
                  </span>
                )}
              </div>
            </div>
          )}
        </div>
      </Layout>
    )
  }
}
export default withRouter(PersonalizarRelatorios)



// WEBPACK FOOTER //
// ./src/views/PersonalizarRelatorios.js